export enum Language {
	English = "en",
	Dutch = "nl",
	French = "fr",
	German = "de-de",
	Italian = "it",
	Spanish = "es",
	Romanian = "ro",
}
